<template>
  <qx-card-form title="收入信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="165px"
    >
      <section slot="priceUnit" slot-scope="prop">
        <el-input
          v-model="prop.form.priceUnit"
          class="inputBox"
          placeholder="请输入金额"
          @blur="calCostPrice"
        >
          <el-select
            class="inputAppendSelect"
            slot="suffix"
            v-model="otherFormData.priceEnum"
            :clear="true"
            @change="calCostPrice"
          >
            <el-option
              v-for="item in priceEnumOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-input>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {isNegativeNumber, dealNumber} from '@qx/utils';
import {mapState} from 'vuex';

export default {
  props: {
    priceEnumOptions: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      otherFormData: {
        priceEnum: '',
      },
      baseForm: {
        inline: true,
        form: [
          {
            label: '收入单价',
            value: 'priceUnit',
            slot: true,
          },
          {
            label: '预估应收',
            value: 'estimateIncome',
            type: 'input',
            width: '240px',
            onChange: () => {
              const estimateIncome = this.$refs.baseForm.getVal('estimateIncome');
              this.$refs.baseForm.setVal('estimateIncome', isNegativeNumber(estimateIncome));
            },
          },
          {
            label: '应付运费',
            value: 'fullFreight',
            type: 'input',
            width: '240px',
            hide: true,
            onInput: (fullFreight) => {
              this.$refs.baseForm.setVal('fullFreight', dealNumber(fullFreight, false));
            },
          },
        ],
        rules: {
          priceUnit: [ // 收入单价
            { required: true, message: '请输入收入单价', trigger: 'blur' },
          ],
          estimateIncome: [ // 预估应收
            { required: true, message: '请输入预估应收', trigger: 'blur' },
          ],
          fullFreight: [ // 应付运费
            { required: true, message: '请输入应付运费', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    calCostPrice () {
      const priceUnit = this.$refs.baseForm.getVal('priceUnit');
      this.$refs.baseForm.setVal('priceUnit', isNegativeNumber(priceUnit));
      this.$emit('calCostPrice');
    },
    async cacheData () {
      const formData = await this.$refs.baseForm.getVal();
      if (formData) {
        formData.priceEnum = this.otherFormData.priceEnum;
      }
      return formData;
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData.priceEnum = this.otherFormData.priceEnum;
      }
      return formData;
    },
    init (data = {}) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: this.userInfo.customerType === '8',
        names: ['fullFreight'],
      });
      const res = {
        priceUnit: data.priceUnit,
        estimateIncome: data.estimateIncome,
        fullFreight: data.fullFreight,
      };
      this.otherFormData.priceEnum = data.priceEnum;
      this.$refs.baseForm.setVal('form', res);
    },
  },
};
</script>

<style scoped lang="scss">
.inputBox {
  margin-right: 12px;
}
</style>
